import * as THREE from 'three';

/**
 * Terrain height function — generates gentle rolling hills.
 * Returns Y offset at any (x, z) world position.
 */
export function terrainHeight(x: number, z: number): number {
  // Primary rolling hills
  const h1 = Math.sin(x * 0.04) * Math.cos(z * 0.04) * 1.5;
  // Secondary smaller undulations
  const h2 = Math.sin(x * 0.1 + 1.3) * Math.cos(z * 0.08 + 0.7) * 0.6;
  // Micro texture
  const h3 = Math.sin(x * 0.2 + 2.1) * Math.cos(z * 0.18 + 1.5) * 0.2;

  return h1 + h2 + h3;
}

/**
 * Displace a PlaneGeometry's vertices to match the terrain height.
 * The plane must be in the XZ plane (rotation [-PI/2, 0, 0]).
 * Expects the geometry to have enough subdivisions.
 */
export function displaceTerrainGeometry(geometry: THREE.PlaneGeometry): void {
  const pos = geometry.attributes.position;
  for (let i = 0; i < pos.count; i++) {
    const x = pos.getX(i);
    const z = pos.getY(i); // plane is in XY before rotation to XZ
    pos.setZ(i, terrainHeight(x, z));
  }
  pos.needsUpdate = true;
  geometry.computeVertexNormals();
}
